import _ from 'lodash'
import React from 'react'
import { Form, Grid } from 'semantic-ui-react'

import { tr } from '../../helpers/languages'
import { timezones } from '../../helpers/timezones'

const F = (props) => {
    return (
        <Form autoComplete="new-password">
            <Grid divided className='others'>
                <Grid.Row columns={2}>
                    <Grid.Column className='first'>
                        <Grid>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.Input
                                        name='email'
                                        type='email'
                                        label={tr('EMAIL_ADDRESS')}
                                        disabled
                                        value={props.email}
                                        autoComplete="new-password"
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            {/*<Grid.Row columns={1}>*/}
                            {/*    <Grid.Column className='right aligned'>*/}
                            {/*        <Form.Input*/}
                            {/*            name='pphone'*/}
                            {/*            type='tel'*/}
                            {/*            label={tr('PHONE')}*/}
                            {/*            value={props.phone}*/}
                            {/*            autoComplete="new-password"*/}
                            {/*            maxLength={20}*/}
                            {/*            error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.phone)}*/}
                            {/*            onChange={(e) => { props.onChangeValue('phone', e.target.value) }}*/}
                            {/*        />*/}
                            {/*        {*/}
                            {/*            !_.isEmpty(props.errors) && !_.isEmpty(props.errors.phone) && (*/}
                            {/*                <div className='error-message'>{props.errors.phone}</div>*/}
                            {/*            )*/}
                            {/*        }*/}
                            {/*    </Grid.Column>*/}
                            {/*</Grid.Row>*/}
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.Input
                                        name='ppassword'
                                        type='password'
                                        label={tr('PASSWORD')}
                                        value='c8ip'
                                        autoComplete="new-password"
                                    />
                                    <div
                                        className='change-password'
                                        tabIndex={0}
                                        role='link'
                                        onClick={(_e) => { props.onChangePassword() }}
                                    >
                                        {tr('CHANGE')}
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid
                                            name='firstName'
                                            label={tr('FIRST_NAME')}
                                            maxLength={30}
                                            value={props.firstName}
                                            autoComplete="new-password"
                                            error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.name)}
                                            onChange={(e) => { props.onChangeValue(e.target.name, e.target.value) }}
                                        />

                                        <Form.Input
                                            fluid
                                            name='lastName'
                                            label={tr('LAST_NAME')}
                                            maxLength={30}
                                            value={props.lastName}
                                            autoComplete="new-password"
                                            error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.surname)}
                                            onChange={(e) => { props.onChangeValue(e.target.name, e.target.value) }}
                                        />
                                    </Form.Group>
                                    {
                                        ((!_.isEmpty(props.errors) && !_.isEmpty(props.errors.name)) || (!_.isEmpty(props.errors) && !_.isEmpty(props.errors.surname))) && (
                                            <div
                                                className='error-message'>{_.isEmpty(props.errors.name) ? props.errors.surname : props.errors.name}</div>
                                        )
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                    <Grid.Column className='second'>
                        <Grid>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.TextArea
                                        name='bio'
                                        label={tr('SOMETHING_ABOUT_YOU')}
                                        maxLength={600}
                                        value={props.bio}
                                        autoComplete="new-password"
                                        error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.bio)}
                                        onChange={(e) => { props.onChangeValue(e.target.name, e.target.value) }}
                                    />
                                    {
                                        !_.isEmpty(props.errors) && !_.isEmpty(props.errors.bio) && (
                                            <div className='error-message right-error'>{props.errors.bio}</div>
                                        )
                                    }
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.TextArea
                                        name='education'
                                        label={tr('EDUCATION')}
                                        maxLength={400}
                                        value={props.education}
                                        autoComplete="new-password"
                                        error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.education)}
                                        onChange={(e) => { props.onChangeValue(e.target.name, e.target.value) }}
                                    />
                                    {
                                        !_.isEmpty(props.errors) && !_.isEmpty(props.errors.education) && (
                                            <div className='error-message right-error'>{props.errors.education}</div>
                                        )
                                    }
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <Form.Dropdown
                                        selection
                                        icon='angle down'
                                        name='timezone'
                                        options={timezones.sort((a, b) => a.text > b.text ? 1 : -1)
                                            .map((tz) => { return { value: tz.utc[0], text: tz.text } })}
                                        label={tr('TIMEZONE')}
                                        value={props.timezone}
                                        autoComplete="new-password"
                                        onChange={(e, { value }) => { props.onChangeValue('timezone', value) }}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1}>
                    <Grid.Column className='center aligned'>
                        <Form.Button
                            onClick={(_e) => { props.onSave() }}
                        >
                            {tr('SAVE')}
                        </Form.Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form>
    )
}

export default F



// WEBPACK FOOTER //
// ./src/components/profile/form.js